import { useQuery } from '@tanstack/react-query';
import { fetchActiveDocumentTypes } from '../../../../api/administration/edmsSettings/documentTypes';

export const useActiveDocumentTypes = (options = {}) => {
  const query = useQuery({
    queryKey: ['documentTypes', 'active'],
    queryFn: () => fetchActiveDocumentTypes(),
    enabled: options.enabled !== false,
  });

  console.log(query.data?.data);

  return {
    ...query,
    documentTypes: query.data?.data ?? [],
  };
};

export default useActiveDocumentTypes;
